import { render, staticRenderFns } from "./OpportunityIcon.vue?vue&type=template&id=45c61dd8&scoped=true&"
import script from "./OpportunityIcon.vue?vue&type=script&lang=js&"
export * from "./OpportunityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c61dd8",
  null
  
)

export default component.exports